import styled from 'styled-components';

import { MOBILE } from '@minerva-analytics/pantheon';

export const PageContainer = styled.div`
  padding-top: 3rem;
  min-height: 75%;

  @media (max-width: ${MOBILE}) {
    padding-top: 2rem;
  }
`;
